<script setup lang="ts">
import { useWorkspaceDisplayNames } from '#layers/workspace/composables/use-workspace-display-names';
import { useWorkspaceStore } from '#layers/workspace/stores/workspace';

const { currentWorkspace } = useWorkspaceStore();
const { getWorkspaceDisplayName } = useWorkspaceDisplayNames();
</script>

<template>
	<span class="truncate text-sm font-semibold">{{ getWorkspaceDisplayName(currentWorkspace) }}</span>
</template>
